<template>
  <router-view></router-view>
</template>
<script type="text/javascript">
export default {
  name: 'FormContainer'
}

</script>



// WEBPACK FOOTER //
// src/Dw/FormManagement/FormContainer.vue